var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"compRenderer"}},[_c('div',{staticClass:"action-btns-box"},[_c('router-link',{attrs:{"to":`/compliance/update/${_vm.data.row.id}`}},[_c('i',{staticClass:"mdi mdi-pencil mr-3 action-icon"})]),_c('i',{staticClass:"mdi mdi-delete action-icon",on:{"click":function($event){return _vm.onDeleteCompliance()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }